var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cart-count"},[_c('span',{staticClass:"cart-count__icon"},[_c('icon',{attrs:{"name":"cart"}}),_c('span',{staticClass:"cart-count__value"},[_vm._v("\n      "+_vm._s(_vm.cartItemsCount)+"\n    ")])],1),_c('span',{staticClass:"cart-count__title"},[_vm._v("\n    "+_vm._s(_vm.$t("event.servicesOrder.servicesCartBtn"))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }